// extracted by mini-css-extract-plugin
module.exports = {"styledModal":"gCdmH71p","text":"Z3WZQ9T5"};